<template>

  <!-- Page Search -->
  <div
    class="page-search">

    <transition
      leave-active-class="animated slideOutUp"
      enter-active-class="animated slideInDown">

      <template
        v-if="displayed">

        <q-toolbar
          v-click-outside="hide"
          class="page-search__toolbar bs-px">

          <q-form
            @submit="submit"
            class="page-search__form">

            <q-input
              dark
              autofocus
              v-model="query"
              class="page-search__input"
              placeholder="введите запрос"/>

            <q-btn
              flat
              dense
              stretch
              color="white"
              type="submit"
              :loading="loading"
              class="page-search__search q-px-sm">

              <svg
                width="29"
                height="29"
                fill="currentColor"
                viewBox="0 0 48 48">

                <use
                  xlink:href="/images/icons/icon-symbols.svg?v1#search"/>

              </svg>

            </q-btn>

          </q-form>

        </q-toolbar>

      </template>

    </transition>

  </div>

</template>

<script>

  import {mapActions, mapGetters} from 'vuex';

  export default {
    name: 'page-search',
    props: {},
    data() {
      return {
        query: '',
        displayed: false,
      };
    },
    computed: {
      ...mapGetters('search', {
        loading: 'loading',
      }),
    },
    methods: {
      ...mapActions('search', {
        search: 'SEARCH',
      }),
      show() {

        this.displayed = true;
      },
      hide() {

        this.displayed = false;
      },
      submit() {

        this.search(this.query);
      },
    },
  };

</script>

<style lang="scss">

  .page-search {
    color: inherit;

    &__toolbar {
      top: 0;
      left: 0;
      width: 100%;
      display: flex;
      position: absolute;
      align-items: center;
      height: $page-header-height;
      background-color: $secondary;

      @media (max-width: $breakpoint-sm) {
        height: $page-header-height-sm;
      }

      @media (max-width: $breakpoint-xs) {
        height: $page-header-height-xs;
      }
    }

    &__form {
      flex: 1;
      display: flex;
    }

    &__input {
      flex: 1;
    }

    input {
      height: 40px;
      margin-top: 16px;
      font-size: 1.4rem;
      text-align: center;
    }

    &__search {
      margin-left: 14px;
      margin-right: -20px;
    }

    .q-field--standard .q-field__control:after {
      color: white;
    }

    .q-field--dark .q-field__control:before {
      border-width: 2px;
      border-color: white;
    }
  }

</style>
